import React from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import { Flex } from 'reflexbox'
import { nest, lifecycle, mapProps, compose } from 'recompose'
import injectSagas from 'helpers/injectSagas'
import CSSModules from 'helpers/CSSModulesUtil'
import hideOnAnyRoles from 'containers/Role/Hide/AllGlobalRoles'
import { GLOBAL_ROLES } from 'containers/Role/constants'
import Body from 'components/typography/body2/index'

import { MODULE_NAME } from './constants'

import {
  fetchAeRegion,
  updateAeRegion,
} from './actions'

import {
  aeRegionSelector,
  aeRegionSelectionSelector
} from './selectors'

import aeRegionSagas from './sagas'
import styles from './styles.scss'

const mapStateToProps = (state) => {
  return {
    projectAeRegions: aeRegionSelector(state),
    aeRegionsSelection: aeRegionSelectionSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAeRegion: (id) => dispatch(fetchAeRegion(id)),
    updateAeRegion: (regions) => dispatch(updateAeRegion(regions))
  }
}

const AeRegionSection = (props) => {  
  const {
    projectAeRegions,
    aeRegionsSelection,
    updateAeRegion,
    edit
  } = props

  return (
    <Flex
      align='center'
      auto
      styleName='userInputContainer'
    >
      <div styleName='userInputHeader'>
        <Body>{'AE Region'}</Body>
      </div>
      <div styleName='userInput'>
        <Select
          placeholder={"Select Region"}
          options={aeRegionsSelection}
          value={projectAeRegions}
          multi={true}
          onChange={updateAeRegion}
          disabled={!edit}
        />      
      </div>
    </Flex>
  )
}

const withLifecycle = lifecycle({
  componentDidMount() {
    const { id, fetchAeRegion } = this.props
    fetchAeRegion(id)
  }
})

const withRoles = compose(
  mapProps(
    (props) => ({
      ...props,
      roles: [
        GLOBAL_ROLES.CLIENT_ACCESS,
      ]
    })
  ),
  hideOnAnyRoles,
)

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({[MODULE_NAME]: aeRegionSagas})
const withStyle = CSSModules(styles)

export default compose(
  withRoles,
  withConnect,
  withSagas,
  withLifecycle,
  withStyle
)(AeRegionSection)
